export default "__VITE_ASSET__b1ee71fb__"